/* eslint-disable @typescript-eslint/no-unsafe-return */
// SOMEHOW THERE IS A BUG AND IT READS THE LIST AS ANY
import { AxiosResponse } from 'axios';
import {
  OrderGetMinDTO,
  OrderTitleMatchingUpdateDTO,
  PurchaseOrderEditDTO,
  PurchaseOrderDeliveryEditDto,
  PurchaseOrderDeliveryGetMinDto, OrderProductGetDTO,
} from 'svila-common';

import { PurchaseOrderGetMinDto } from '../../types/PurchaseOrderGetMinDto';

import { API_URL } from '../../utils/constants';
import request from '../request';
import { WarehouseGetDto } from 'svila-common/types/back-end/warehouseGetDTO';

export default {
  get: async (id: string): Promise<AxiosResponse<PurchaseOrderGetMinDto>> => {
    return request(`${API_URL}/purchase-orders/${id}`, 'get');
  },

  update: async (id: string, values: PurchaseOrderEditDTO): Promise<AxiosResponse<PurchaseOrderGetMinDto>> => {
    const body = JSON.stringify(values);

    return request(`${API_URL}/purchase-orders/${id}`, 'put', body);
  },

  create: async (values: PurchaseOrderEditDTO): Promise<AxiosResponse<PurchaseOrderGetMinDto>> => {
    const body = JSON.stringify(values);

    return request(`${API_URL}/purchase-orders`, 'post', body);
  },

  getWarehoueseForPurchaseOrder: async (id: string): Promise<AxiosResponse<WarehouseGetDto[]>> => {
    return request(`${API_URL}/purchase-orders/get-warehouses/${id}`, 'get');
  },

  delete: async (id: string): Promise<AxiosResponse<PurchaseOrderGetMinDto>> => {
    return request(`${API_URL}/orders/${id}`, 'delete', {}, {});
  },

  getMatchings: async (id: string): Promise<AxiosResponse<OrderGetMinDTO[]>> => {
    return request(`${API_URL}/orders/title-matchings/${id}`, 'get');
  },

  updateMatchings: async (id: string, values: OrderTitleMatchingUpdateDTO,):
    Promise<AxiosResponse<OrderGetMinDTO[]>> => {
    const body = JSON.stringify(values);

    return request(`${API_URL}/orders/title-matchings/${id}`, 'put', body, {});
  },

  printout: async (id: string): Promise<AxiosResponse<OrderGetMinDTO[]>> => {
    return request(`${API_URL}/orders/printout/${id}`, 'get', {}, {});
  },

  createDelivery: async (values: PurchaseOrderDeliveryEditDto,):
    Promise<AxiosResponse<PurchaseOrderDeliveryGetMinDto>> => {
    const body = JSON.stringify(values);

    return request(`${API_URL}/order-deliveries`, 'post', body);
  },

  updateDelivery: async (id: string, values: PurchaseOrderDeliveryEditDto,):
    Promise<AxiosResponse<PurchaseOrderDeliveryGetMinDto>> => {
    const body = JSON.stringify(values);

    return request(`${API_URL}/order-deliveries/${id}`, 'put', body);
  },

  getDeliveries: async (id: string): Promise<AxiosResponse<PurchaseOrderDeliveryGetMinDto[]>> => {
    return request(`${API_URL}/order-deliveries/for-order/${id}`, 'get');
  },

  deleteDelivery: async (id: string): Promise<AxiosResponse<PurchaseOrderDeliveryGetMinDto>> => {
    return request(`${API_URL}/order-deliveries/${id}`, 'delete', {}, {});
  },

  importOrderProducts: async (fileId: string, orderId: string): Promise<AxiosResponse<OrderProductGetDTO[]>> => {
    return request(`${API_URL}/purchase-order-products/import-purchase-order-products/${fileId}/${orderId}`, 'post');
  },

  // getDeliveries: async (id: string): Promise<AxiosResponse<PurchaseOrderDeliveryGetMinDto[]>> => {
  //   return request(`${API_URL}/order-deliveries/${id}`, 'get');
  // },
};
